import { Component } from 'react';

import classnames from 'classnames';
import classBind from 'classnames/bind';
import TextArea from 'components/atoms/textArea/index.jsx';
import Label from 'components/atoms/label/index.jsx';

import styles from './styles.scss';

let cx = classBind.bind(styles);

export default class FormTextArea extends Component {
  render() {
    let { input, label, meta, size, ...etc } = this.props;
    let textAreaSize = size || 'medium';
    let className = cx({
      formTextArea: true,
      last: this.props.last,
      nolabel: this.props.nolabel,
      [`${textAreaSize}`]: true,
    });

    meta = meta || {};

    return (
      <div className={classnames(className)}>
        {label && <Label label={label} />}
        <TextArea input={input} placeholder="" {...etc} />

        {meta.touched && meta.error && <span className="error">{meta.error}</span>}
      </div>
    );
  }
}
